import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
import './afiliacionFlow.css';
import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
    fetchAfiliaciones,
    Afiliacion,
} from '../../../services/afiliadosService';
import GestionAfiliacionModal from './GestionAfiliacionModal';
import NuevaAfiliacionModal from './NuevaAfiliacionModal';
import PagoAfiliacionModal from './PagoAfiliacionModal';
import {
    Building2,
    Search,
    Plus,
    CheckCircle2,
    Clock,
    Gift,
    Shield,
    Sparkles,
    ChevronRight,
    Filter,
    Users,
    Activity,
    ExternalLink,
    AlertCircle,
    Calendar,
    Banknote,
} from 'lucide-react';

const AfiliadosPage: React.FC = () => {
    const [afiliaciones, setAfiliaciones] = useState<Afiliacion[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [searchTerm, setSearchTerm] = useState('');
    const [filterEstado, setFilterEstado] = useState<string>('todos');

    // Modales
    const [afiliacionSeleccionada, setAfiliacionSeleccionada] = useState<Afiliacion | null>(null);
    const [afiliacionParaPago, setAfiliacionParaPago] = useState<Afiliacion | null>(null);
    const [modalNuevaAbierto, setModalNuevaAbierto] = useState(false);

    const loadData = async () => {
        setLoading(true);
        try {
            const data = await fetchAfiliaciones();
            setAfiliaciones(data);
        } catch (err: any) {
            /* Browser diagnostics omitted. */
            setError('No se pudieron cargar las afiliaciones.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const safeAfiliaciones = useMemo(() => {
        if (!Array.isArray(afiliaciones)) return [];
        // Permitir ver domiciliaciones para cualquier rol de usuario
        return afiliaciones.filter(Boolean);
    }, [afiliaciones]);

    const filteredList = useMemo(() => {
        return safeAfiliaciones.filter((item) => {
            if (!item) return false;
            const term = searchTerm.toLowerCase();
            const matchQuery =
                item.empresa_nombre?.toLowerCase().includes(term) ||
                item.nit?.toLowerCase().includes(term) ||
                item.cliente_nombre?.toLowerCase().includes(term) ||
                item.representante_legal?.toLowerCase().includes(term);

            const matchEstado =
                filterEstado === 'todos' || item.estado === filterEstado;

            return matchQuery && matchEstado;
        });
    }, [safeAfiliaciones, searchTerm, filterEstado]);

    const stats = useMemo(() => {
        const total = safeAfiliaciones.length;
        const activos = safeAfiliaciones.filter((a) => a && a.estado === 'activo').length;
        const enProceso = safeAfiliaciones.filter((a) => a && a.estado === 'en_proceso').length;
        const totalHorasDisponibles = safeAfiliaciones.reduce(
            (acc, curr) => acc + Number(curr?.horas_gratuitas_disponibles || 0),
            0
        );
        return { total, activos, enProceso, totalHorasDisponibles };
    }, [safeAfiliaciones]);

    return <><LumaResourceWorkspace title="Afiliados y requisitos" description="Consulta y gestiona la información de tu coworking." group="Correspondencia" rows={afiliaciones} columns={[{key:'empresa_nombre',label:'Empresa'},{key:'cliente_nombre',label:'Cliente titular'},{key:'nit',label:'NIT'},{key:'estado',label:'Estado'},{key:'estado_pago',label:'Pago'}]} idKey="id" nameKey="empresa_nombre" statusKey="estado" canRead={true} onCreate={()=>{setModalNuevaAbierto(true)}} onEdit={undefined} onDelete={undefined} extraActions={r=><><button type="button" onClick={()=>setAfiliacionSeleccionada(r)}>Gestionar requisitos</button><button type="button" onClick={()=>setAfiliacionParaPago(r)}>Registrar pago</button></>}></LumaResourceWorkspace>{afiliacionSeleccionada && (
                <GestionAfiliacionModal
                    afiliacion={afiliacionSeleccionada}
                    onClose={() => setAfiliacionSeleccionada(null)}
                    onUpdated={(actualizada) => {
                        setAfiliaciones((prev) =>
                            prev.map((a) => (a.id === actualizada.id ? actualizada : a))
                        );
                        setAfiliacionSeleccionada(actualizada);
                    }}
                />
            )}{afiliacionParaPago && (
                <PagoAfiliacionModal
                    isOpen={Boolean(afiliacionParaPago)}
                    onClose={() => setAfiliacionParaPago(null)}
                    afiliacion={afiliacionParaPago}
                    onPagoSuccess={() => {
                        loadData();
                    }}
                />
            )}{modalNuevaAbierto && (
                <NuevaAfiliacionModal
                    onClose={() => setModalNuevaAbierto(false)}
                    onCreated={(nueva) => {
                        setAfiliaciones((prev) => [nueva, ...prev]);
                    }}
                />
            )}</>;
};

export default AfiliadosPage;




